import { useEffect, useState } from 'react';
import { eventTypesApi } from '../api/eventTypes';
import type { EventType } from '../api/eventTypes';

/**
 * The unit's live event types, for a picker.
 *
 * Failure is deliberately silent and returns an empty list. A type is optional on every event, so
 * a unit whose types could not be loaded should still be able to post a campout — refusing the
 * whole form over a label would be a worse outcome than the missing label. The picker simply does
 * not render.
 */
export function useEventTypes(unitId: string): EventType[] {
  const [types, setTypes] = useState<EventType[]>([]);

  useEffect(() => {
    let live = true;

    eventTypesApi
      .list(unitId)
      .then((loaded) => live && setTypes(loaded))
      .catch(() => undefined);

    return () => {
      live = false;
    };
  }, [unitId]);

  return types;
}
